import * as React from "react";
import { Helmet } from "react-helmet";
import { Route, Redirect, Switch } from "react-router-dom";
import AcornsFaq from "./AcornsFaq/AcornsFaq";
import styled from "../../styled-components";
import AcornsIndex from "./AcornsIndex/AcornsIndex";
import { media } from "../../breakpoints";

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background: transparent;

  ${media.TABLET`
    background-position: center center;
    background-size: auto 200%;
  `};
`;

const MainContent = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.white};
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
`;

const Acorns: React.SFC<{}> = () => (
  <>
    <Helmet>
      <title>Say - Acorns</title>
      <meta property="og:title" content="Say - Acorns" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Sign up for Say." />
      <meta property="og:url" content="https://saytechnologies.com/acorns" />
    </Helmet>

    <Wrapper>
      <MainContent>
        <Switch>
          <Route exact={true} path={"/acorns"} component={AcornsIndex} />
          <Route exact={true} path="/acorns/faq" component={AcornsFaq} />
          <Redirect to="/acorns" />
        </Switch>
      </MainContent>
    </Wrapper>
  </>
);

export default Acorns;



// WEBPACK FOOTER //
// ./src/pages/Acorns/Acorns.tsx